import { ChevronLeft, ChevronRight } from "lucide-react";
import { clsx } from "clsx";
import { Button } from "../ui";

/**
 * ‹ [Today] › with the shown period beside it, for pages that step through days or weeks (planner,
 * worklog). The middle button jumps back to the current period and is quiet while already there.
 */
export function DateNav({
  label,
  current,
  currentLabel,
  prevLabel,
  nextLabel,
  onPrev,
  onNext,
  onCurrent,
  testId,
}: {
  /** the shown day or week, in words */
  label: string;
  /** whether the shown period is the current one */
  current: boolean;
  currentLabel: string;
  prevLabel: string;
  nextLabel: string;
  onPrev(): void;
  onNext(): void;
  onCurrent(): void;
  testId?: string;
}) {
  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <span className="text-sm text-neutral-700 dark:text-neutral-200" data-testid="date-nav-label">
        {label}
      </span>
      <div className="flex items-center rounded-md border border-neutral-200 bg-[var(--surface)] p-0.5 dark:border-neutral-800">
        <Button
          variant="ghost"
          size="sm"
          className="w-[30px] px-0"
          aria-label={prevLabel}
          title={prevLabel}
          onClick={onPrev}
          data-testid="date-nav-prev"
        >
          <ChevronLeft size={16} aria-hidden />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className={clsx("px-3", current && "text-neutral-400")}
          aria-current={current ? "date" : undefined}
          onClick={onCurrent}
          data-testid="date-nav-current"
        >
          {currentLabel}
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="w-[30px] px-0"
          aria-label={nextLabel}
          title={nextLabel}
          onClick={onNext}
          data-testid="date-nav-next"
        >
          <ChevronRight size={16} aria-hidden />
        </Button>
      </div>
    </div>
  );
}
